import { useSyncExternalStore } from 'react';
import { getIdentity, subscribeIdentity } from './identity';
/** Subscribe a component to the current mock identity (role + username). */
export function useIdentity() {
    return useSyncExternalStore(subscribeIdentity, getIdentity, getIdentity);
}
